// Footer.js

import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './styles/Footer.css';

function getLastUpdated() {
  const ts = Number(localStorage.getItem('cacheVersion') || 0);
  if (!ts) return null;
  const mins = Math.round((Date.now() - ts) / 60000);
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  return hrs < 24 ? `${hrs}h ago` : `${Math.round(hrs / 24)}d ago`;
}

function Footer() {
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    setLastUpdated(getLastUpdated());
    // Refresh every minute so the relative time stays accurate
    const id = setInterval(() => setLastUpdated(getLastUpdated()), 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          &copy; {new Date().getFullYear()} — YellowMythics
          {lastUpdated && (
            <span className="footer-updated"> · Updated {lastUpdated}</span>
          )}
        </p>
        {/*
        <div className="footer-links">
          <NavLink exact="true" to="/privacy-policy" className="footer-link">Privacy Policy</NavLink>
          <NavLink exact="true" to="/disclaimer" className="footer-link">Disclaimer</NavLink>
        </div>
        */}
      </div>
    </footer>
  );
}

export default Footer;
